'use strict';

import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot} from '@angular/router';
import {AuthService} from "./auth.service";
import {JwtHelper} from "angular2-jwt";
import {AuthenticationService} from "../authentication.service";

@Injectable()
export class RoleLoginGuardService implements CanActivate {

    constructor(
        private authService: AuthService,
        private router: Router,
        private authenticationService: AuthenticationService) {
    }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        if (localStorage.getItem('userToken')) {
            // is not login
            if (!this.authService.isAuthenticated()) {
                this.authenticationService.logout();
                this.router.navigate(['/login']);

                return true;
            }

            const expectedRole = route.data.expectedRole;
            const tokenPayload = this.authenticationService.checkRoleUser();
            // Check Role
            if (typeof expectedRole === 'undefined' || (this.authService.isAuthenticated() && (!tokenPayload.isAdmin && expectedRole.indexOf(tokenPayload.role) !== -1))) {
                // 1. Not Admin
                // 2. Not define data expectedRole in router
                // Result: redirect page home
                this.router.navigate(['/']);
                return false;
            } else {
                // Is current Admin
                // Result: next all pages
                return true;
            }
        } else {
            return true;
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/auth/role-login-guard.service.ts